/* ============================================================
   wow-card.js
   Ajout au panier en AJAX pour les cartes produit enrichies.

   Pourquoi une délégation d'événement plutôt qu'une boucle sur
   les formulaires : ce script est chargé une seule fois pour tout
   le site, alors que les cartes apparaissent en nombre variable et
   parfois APRÈS le chargement de la page (filtres de collection,
   pagination infinie, tiroir de recherche). Un écouteur unique posé
   sur le document capte aussi bien les cartes présentes au départ
   que celles injectées plus tard — une boucle, elle, ne verrait
   jamais les secondes.
   ============================================================ */

(function () {
  'use strict';

  document.addEventListener('submit', function (evt) {
    var form = evt.target.closest('.fp-card__form');
    if (!form) return;

    evt.preventDefault();

    var button = form.querySelector('.fp-card__button');
    if (!button || button.disabled || button.classList.contains('is-loading')) return;

    var formData = new FormData(form);
    button.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw err;
          });
        }
        return res.json();
      })
      .then(function () {
        button.classList.remove('is-loading');
        button.classList.add('is-added');

        // Rafraîchit la pastille du panier si le thème en a une.
        // Best effort : un échec ici ne doit pas casser l'ajout lui-même,
        // qui a déjà réussi côté serveur.
        fetch('/cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));

            var bubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
            if (bubble) bubble.textContent = cart.item_count;

            var bubbleWrap = document.querySelector('.cart-count-bubble');
            if (bubbleWrap) bubbleWrap.hidden = false;
          })
          .catch(function () {});

        setTimeout(function () {
          button.classList.remove('is-added');
        }, 1600);
      })
      .catch(function () {
        // Repli : si l'AJAX échoue (réseau, stock épuisé entre-temps),
        // on laisse le formulaire partir en soumission classique pour
        // que le client voie le message d'erreur natif de Shopify.
        button.classList.remove('is-loading');
        form.submit();
      });
  });
})();